import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { NumericFormat } from "react-number-format";
import { useModalContext } from '../../contexts/ModalContext';
import { useToast } from '../../hook/usetoast';
import { useGetKKOG, useGetVRS, useGetWithDraw, useWithdraw } from './api';
import Web3 from 'web3';
import tokens from '../web3/contractAddress';
import { useGetMyToken, useGetProfile } from '../Myprofile/api';
import { ExternalLink } from 'lucide-react';
import { transactionurl } from '../../lib/transactionurl';
import {
    useConnect,
    useAccount,
    useSwitchNetwork,
    useDisconnect,
    useNetwork,
} from "wagmi";
import { chainId } from '../web3/chain';
import { getProvider } from '../web3/getProvider'
import claimApi from '../web3/claimAbi.json'
import Loader from '../../Loader/buttonLoad';
import { useTranslation } from 'react-i18next';

const Withdraw = (props) => {
    const toast = useToast()
    const [modal, setModal] = useState(false);
    const [value, setValue] = useState('');


   



    const { isloading, setIsloading } = useModalContext();
    const { data: getProfile , isLoading} = useGetProfile()
    const {t} = useTranslation()

    const [page, setPage] = useState(1);
    const size = 10
    const withDraw = useWithdraw()
    const { data: withDrawHistory, refetch } = useGetWithDraw({
        page,
        size,
    })
    const { data: minKKOG } = useGetKKOG()
    const { data: myToken } = useGetMyToken()

    const USDAmount = getProfile?.balance?.currencyBalance * myToken?.data?.KKOG_Details?.usd_price

    const [error, setError] = useState('');

    const total = withDrawHistory?.count || 0

    const totalPages = Math.ceil(total / size);

    useEffect(() => {
        refetch()
    }, [page, size])

    const toggleWdMdl = () => {
        setModal(!modal);
        setValue('')

    }



    const { connectAsync, connectors } = useConnect();
    const { disconnectAsync } = useDisconnect();
    const { address, isConnected } = useAccount();
    const { chain: network } = useNetwork()
    const chainid = network?.id
    const { switchNetworkAsync } = useSwitchNetwork({
        chainId: chainId.BNB,
        throwForSwitchChainNotSupported: true,
    });


    const provider = getProvider()

    const web3 = new Web3(provider)






    const handleValueChange = (e) => {
        const value = e.target.value;

        // Check if the input is a valid number
        const parsedValue = parseFloat(value);


        if (parsedValue < minKKOG?.data?.min_withdraw) {
            setError(t(`Minimum withdraw amount is ${minKKOG?.data?.min_withdraw}`));
        }
        else if (parsedValue > minKKOG?.data?.max_withdraw) {
            setError(t(`Maximum withdraw amount is ${minKKOG?.data?.max_withdraw}`));
        }
        else {
            setError('');
        }

        setValue(value);
    };

    const getVRS = useGetVRS()
    const onConnectWalletClick = async () => {
        setIsloading(true)
        if (isConnected) {
            setIsloading(false)
            return;
        }

        try {
            setIsloading(true)

            const connectedAccount = await connectAsync({ connector: connectors[0] });


            if (connectedAccount.chain.id !== chainId.BNB) {
                await switchNetworkAsync();
            }

            if (getProfile?.data?.walletAddress.toLowerCase() !== connectedAccount.account.toLowerCase()) {
                await disconnectAsync();
                return toast.error(t("Connect User address"));
            }
            toast.success(t("Wallet connected successfully"));

            localStorage.setItem("account", connectedAccount.account);

        } catch (error) {
        } finally {
            setIsloading(false)

        }
    };






    const onSubmit = async (data) => {
        setIsloading(true)

        if (!isConnected) {

            setIsloading(false)

            return toast.error(t("Connect Wallet"))
        }

        try {
            setIsloading(true)

            const blockNumber = await web3.eth.getBlockNumber();
            if (chainid !== chainId.BNB) {
                await switchNetworkAsync(chainId.BNB);
            }
            const numberblock = blockNumber.toString()
            const AddBlock = parseFloat(numberblock) + 100

            const valueInWei = web3.utils.toWei(value, 'ether');

            const claimContract = new web3.eth.Contract(claimApi, tokens?.CLAIM)

            const userclaimamount = await claimContract.methods.userClaimedAmount(getProfile?.data?.walletAddress).call()
            const valueclaim = web3.utils.fromWei(userclaimamount, 'ether');
            const getVrs = await claimContract.methods.message(address, valueInWei, AddBlock).call()

            const response = await getVRS.mutateAsync({ hash: getVrs,userClaimedAmount:valueclaim })

            const claimTx = await claimContract.methods.claim(tokens?.KKOGTOKEN, getProfile?.data?.walletAddress, valueInWei, AddBlock, response?.signdata?.signature).send({ from: address, gas: 5000000 })

            if (claimTx?.transactionHash) {

                const res = await withDraw.mutateAsync({
                    address: getProfile?.data?.walletAddress,
                    amount: value,
                    trx_id: claimTx?.transactionHash
                })
                if (res?.status) {
                    setModal(false)
                    setValue('')

                }

            }
        } catch (error) {
            if (error.message.includes(t('MetaMask Tx Signature: User denied transaction signature.'))) {
                setIsloading(false)
                setModal(false)
                toast.error(t('Transaction rejected by user.'));
            } else if (error.message.includes(t('Transaction has been reverted by the EVM:'))) {
                setModal(false)
                toast.error(t('Transaction has been reverted by the EVM'));

            }
        } finally {
            setIsloading(false)

        }
    }





    return (
        <>
            {isloading && <Loader />}
            <div className='TrnsctnPg'>
                <div className="TrnsctnDts">
                    <div className="TrnsctnDtsTp">
                        <h4>{t('Withdraw KKOG Token')}</h4>
                    </div>
                    <div className='WdTotBl'>
                        <div className='Ldv'>
                            <label>{t('Total Balance')}</label>
                            <h5>{isLoading ? '' :parseFloat(getProfile?.balance?.currencyBalance).toFixed(2)} KKOG</h5>
                            <h6>{t('Equivalent to')} {isLoading ? '' : USDAmount && parseFloat(USDAmount).toFixed(2)} USD</h6>
                        </div>
                        <button className='btn CmnBtn' onClick={toggleWdMdl}>{t('Withdraw')}</button>
                    </div>
                    <div className='table-responsive px-3'>
                        <table className='table' aria-hidden='true'>
                            <thead>
                                <th>{t('S.No')}</th>
                                <th>{t('Amount')}</th>
                                <th>{t('To')}</th>
                                <th>{t('Transaction Hash')}</th>
                                <th>{t('Status')}</th>
                                <th>{t('Date & Time')}</th>
                            </thead>
                            <tbody>
                                {withDrawHistory?.data && withDrawHistory.data.length > 0 ? (
                                    withDrawHistory.data.map((withdrawal, index) => (
                                        <tr key={withdrawal}>

                                            <td>{index + 1}</td>
                                            <td>{withdrawal.amount} KKOG</td>
                                            <td>
                                                {withdrawal.address ?
                                                    `${withdrawal.address.slice(0, 10)}...${withdrawal.address.slice(-7)}` : "-"}
                                            </td>
                                            <td>{withdrawal.trx_id ?
                                                withdrawal.trx_id?.slice(0, 8) + "..." + withdrawal.trx_id?.slice(-7) : "-"}
                                               
                                                <a
                                                    href={transactionurl["bsc"] + withdrawal.trx_id}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "black" }}
                                                    className='ml-2'
                                                >
                                                    {withdrawal.trx_id ? <ExternalLink size={20} /> : ""}
                                                </a>

                                            </td>
                                            <td className='text-success'>{withdrawal.status === 'completed' ? "Completed":"Inprogress"}</td>
                                            <td>{new Date(withdrawal.createdAt).toLocaleString()}</td>
                                            <td></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center' }}>{t('No data found')}</td>
                                    </tr>
                                )}



                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="PgntnDv">
                    <span>
                        {t('Showing')} {total > 0 ? (page - 1) * size + 1 : 0} {t('to')} {Math.min(page * size, total)} {t('of')} {total} {t('entries')}
                    </span>
                    <nav aria-label="Page navigation example">
                        <ul className="pagination">
                            {page > 1 && (
                                <li className="page-item">
                                <button style={{all:"unset",cursor:"pointer"}} onClick={() => setPage(page - 1)}>
                                    <span className="page-link"  >
                                        {t('Previous')}
                                    </span>
                                </button>
                                </li>
                            )}
                            {totalPages > 0 && Array.from({ length: totalPages }, (_, index) => (
                                <li key={index} className={`page-item ${page === index + 1 ? 'active' : ''}`}>
                                <button style={{all:"unset",cursor:"pointer"}}  onClick={() => setPage(index + 1)}>
                                    <span
                                        className="page-link"
                                        
                                    >
                                        {index + 1}
                                    </span>
                                 </button>

                                </li>
                            ))}
                            {page < totalPages && (
                                <li className="page-item">
                                <button style={{all:"unset",cursor:"pointer"}}  onClick={() => setPage(page + 1)} >
                                    <span className="page-link" >
                                        {t('Next')}
                                    </span>
                                 </button>
                                </li>
                            )}
                        </ul>
                    </nav>
                </div>

                <Modal isOpen={modal} toggle={toggleWdMdl} className='CmnMdl modal-dialog-centered'>
                    <div className='MdlHdr'>
                        <h5>{t('Withdraw')}</h5>
                        <button className='EpySty' onClick={toggleWdMdl}><img src={require('../../assets/images/close-circle.png')} alt='' /></button>
                    </div>
                    <ModalBody className='MdlBdy WDMdlBody'>
                        <label className='d-block'>{t('Total Balance')}</label>
                        <h5>{getProfile?.balance?.currencyBalance} KKOG</h5>
                        <h6>{t('Equivalent to')} {parseFloat(USDAmount).toFixed(2)} USD</h6>
                        <div className='WdMdlFrmGrp'>
                            <div className='form-group'>
                                <label>{t('Enter Amount')}</label>
                                <NumericFormat
                                    value={value}
                                    className="form-control"
                                    placeholder="0.00"
                                    allowNegative={false}
                                    onChange={handleValueChange}

                                />
                                {error && <div className="error-message" style={{ color: 'red' }}>{error}</div>}

                            </div>
                            <div className='form-group PrflFrmGrpCB'>
                                <label>{t('Wallet Address')}</label>
                                <input className='form-control' type='text' value={getProfile?.data?.walletAddress ?
                                    `${getProfile?.data?.walletAddress.slice(0, 10)}...${getProfile?.data?.walletAddress.slice(-7)}` : "Wallet Address"} readOnly placeholder='Wallet Address' />
                                {isConnected && getProfile?.data?.walletAddress ?
                                    <span >
                                        <button
                                            type="button"
                                            className="InputIcon EpySty eyeslsIg text-success"

                                        >
                                            {t('Connected')}

                                        </button>
                                    </span>
                                    :
                                    getProfile?.data?.walletAddress && <span >
                                        <button
                                            type="button"
                                            className="InputIcon EpySty eyeslsIg text-danger"
                                            onClick={onConnectWalletClick}
                                        >
                                            {t('Connect Wallet')}

                                        </button>
                                    </span>
                                }


                            </div>
                            
                            <div className='form-group'>
                                <button className='btn CmnBtn px-4 mx-auto' onClick={onSubmit} disabled={getProfile?.data?.walletAddress === '' || getProfile?.data?.walletAddress === undefined || value > getProfile?.balance?.currencyBalance || value == 0 || value == '' || error || !isConnected}>{t('Withdraw')}</button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        </>

    );
}

export default Withdraw;